import React from 'react';
import { Col, Tag, Input, InputNumber, Row } from "antd";
import Icon from "../../tools/icon/Icon";
import ColorPicker from "../../tools/common/ColorPicker.js";
import { tText } from '../../../assets/libs/i18n/translator';

const TextPropertiesPanel = ({ selectedItem, form }) => {
        return (
                <>
                        <Row>
                                <Col span={24} className="mb-1">
                                        <h3 className="text-center">{tText("title")}</h3>
                                </Col>
                        </Row>
                        <Row>
                                <Col span={24} className="mb-2">
                                        {form('text', {
                                                initialValue: selectedItem.text,
                                        })(
                                                <Input />,
                                        )}
                                </Col>
                                <Col span={12} className="mb-2">
                                        <label>{tText("fontSize")}</label>
                                </Col>
                                <Col span={12} className="mb-2">
                                        {form('fontSize', {
                                                initialValue: selectedItem.fontSize || '32',
                                        })(
                                                <InputNumber min={1} />,
                                        )}
                                </Col>
                                <Col span={12} className="mb-2">
                                        <label>{tText("fontStyle")}</label>
                                </Col>
                                <Col span={3} className="mb-2">
                                        {form('checkFontWeight', {
                                                valuePropName: 'checked',
                                                initialValue: selectedItem.checkFontWeight,
                                        })(
                                                <Tag.CheckableTag className="rde-action-tag">
                                                        <Icon name="bold" />
                                                </Tag.CheckableTag>,
                                        )}
                                </Col>
                                <Col span={3} className="mb-2">
                                        {form('checkFontStyle', {
                                                valuePropName: 'checked',
                                                initialValue: selectedItem.checkFontStyle,
                                        })(
                                                <Tag.CheckableTag className="rde-action-tag">
                                                        <Icon name="italic" />
                                                </Tag.CheckableTag>,
                                        )}
                                </Col>
                                <Col span={3} className="mb-2">
                                        {form('linethrough', {
                                                valuePropName: 'checked',
                                                initialValue: selectedItem.linethrough,
                                        })(
                                                <Tag.CheckableTag className="rde-action-tag">
                                                        <Icon name="strikethrough" />
                                                </Tag.CheckableTag>,
                                        )}
                                </Col>
                                <Col span={3} className="mb-2">
                                        {form('underline', {
                                                valuePropName: 'checked',
                                                initialValue: selectedItem.underline,
                                        })(
                                                <Tag.CheckableTag className="rde-action-tag">
                                                        <Icon name="underline" />
                                                </Tag.CheckableTag>,
                                        )}
                                </Col>
                                <Col span={12} className="mb-2">
                                        <label>{tText("fillColor")}</label>
                                </Col>
                                <Col span={12} className="mb-2">
                                        {form('fill', {
                                                initialValue: selectedItem.fill || 'rgba(0, 0, 0, 1)',
                                        })(<ColorPicker />)}
                                </Col>
                        </Row>
                </>
        );
}

export { TextPropertiesPanel };
